const wordLibrary = {
  COVID_19: 'COVID-19',
  Data_and_Analytics: 'Data & Analytics',
  Return_to_work: 'Return-to-Work',
} as const;

export default wordLibrary;
